import { reactive } from "vue";
import axios from "@/axios";

function readSaved() {
  try {
    return JSON.parse(localStorage.getItem("permissions")) || {};
  } catch (_) {
    return {};
  }
}

/** Reactive so the sidebar and pages redraw when fresh permissions arrive. */
export const permState = reactive({
  perms: readSaved(),
});

export function setPermissions(perms) {
  permState.perms = perms || {};
  localStorage.setItem("permissions", JSON.stringify(permState.perms));
}

export function clearPermissions() {
  permState.perms = {};
  localStorage.removeItem("permissions");
}

/** Reload this user's permissions from the server. Failures keep the saved permissions. */
export async function refreshPermissions() {
  if (!localStorage.getItem("auth_token")) return;
  try {
    const { data } = await axios.get("/user/me/permissions/", { timeout: 5000 });
    setPermissions(data);
  } catch (_) {
    /* keep the saved permissions */
  }
}

export function hasPermission({ code, level }) {
  const current = permState.perms[code] || permState.perms["*"];
  if (!current) return false;

  return current.includes(level);
}

/** Every character of ``requiredLevel`` (e.g. "RW") must be granted. */
export function can(code, requiredLevel) {
  const current = permState.perms[code] || permState.perms["*"] || "N";
  return [...requiredLevel].every(char => current.includes(char));
}

/** Admin: staff flag, Admin role name, or wildcard permissions. */
export function isAdminUser() {
  if (localStorage.getItem("is_staff") === "true") return true;

  try {
    const role = JSON.parse(localStorage.getItem("role"));
    if (typeof role === "string" && role.toLowerCase() === "admin") {
      return true;
    }
  } catch (_) {
    /* ignore */
  }

  return !!permState.perms["*"];
}

/** Routes only Admin may open (Finance & Accounts). User Management follows rbac.* permissions. */
export function isAdminOnlyPath(path) {
  return path.startsWith("/account/") || path.includes("/head/");
}
